/* Session page "Change penalty" pop-up "Download CSV": pure column maps over session_view rows. */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { EM_DASH } from '../../teacher_payments/format';

const raw = (r) => r.row || {};
const money = (r) => raw(r).money || {};
const nullable = (v) => (v === null || v === undefined ? '' : v);
const shown = (v) => (v === EM_DASH ? '' : v);

// Full uuid: exports never shorten an id.
export const session_penalty_csv_name = (session_uuid, table) =>
  csv_file_name({ page: `session-${String(session_uuid || '')}`, table });

// Penalties on this session. Amounts are rupees deducted (positive), as the server stores them.
export const SESSION_PENALTY_CSV_COLUMNS = [
  { header: 'Penalty ID', key: 'uuid' },
  { header: 'Teacher', value: (r) => raw(r).teacher_name || '' },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Pay month', key: 'pay_month' },
  { header: 'Session date (IST)', value: (r) => raw(r).session_start_ist, kind: 'datetime' },
  { header: 'Session UUID', key: 'session_uuid' },
  { header: 'Penalty', key: 'type_text' },
  { header: 'Source', key: 'source_text' },
  { header: 'Base rate', value: (r) => raw(r).base_rate_used, kind: 'money' },
  { header: 'Pen %', value: (r) => (r.session_uuid ? raw(r).penalty_pct : ''), kind: 'number' },
  { header: 'Original', value: (r) => raw(r).original_amount, kind: 'money' },
  { header: 'Corrected', value: (r) => nullable(raw(r).corrected_amount), kind: 'money' },
  { header: 'Charged', value: (r) => money(r).charged, kind: 'money' },
  { header: 'Waived', value: (r) => money(r).waived, kind: 'money' },
  { header: 'Free Pass', value: (r) => money(r).pass, kind: 'money' },
  { header: 'Status', value: (r) => shown(r.waiver_text) },
  { header: 'State', key: 'state_text' },
  { header: 'Reason', key: 'reason_text' },
  { header: 'Note', key: 'note' },
  { header: 'Updated by', value: (r) => raw(r).updated_by_name || raw(r).updated_by || '' },
  { header: 'Updated at (IST)', value: (r) => raw(r).updated_at_ist, kind: 'datetime' }
];

// Penalty history rows: at_text is "<at_ist> IST" (or a dash); the key leads with the penalty uuid.
export const SESSION_PENALTY_HISTORY_CSV_COLUMNS = [
  {
    header: 'When (IST)',
    value: (h) => String(h.at_text || '').replace(/ IST$/, ''),
    kind: 'datetime'
  },
  { header: 'By', value: (h) => shown(h.by_text) },
  { header: 'Teacher', value: (h) => shown(h.teacher_name) },
  { header: 'Change', key: 'action_text' },
  { header: 'Summary', key: 'summary' },
  { header: 'Note', key: 'reason' },
  { header: 'Penalty ID', value: (h) => String(h.key || '').split('|')[0] }
];

// History rows carry no session uuid of their own; the page's session leads each row.
export const session_penalty_history_csv_columns = (session_uuid) => [
  { header: 'Session UUID', value: () => session_uuid || '' },
  ...SESSION_PENALTY_HISTORY_CSV_COLUMNS
];
